import React from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface DialogContentLoadingProps {
  loadingText: string;
}

const DialogContentLoading: React.FC<DialogContentLoadingProps> = ({ loadingText }) => {
  return (
    <>
      <CircularProgress sx={{ marginTop: 1 }} size={50} />
      <Typography variant="body1">{loadingText}</Typography>
    </>
  );
};

export default DialogContentLoading;
